module.exports = __webpack_public_path__ + "img/yblogin_logo.f968fb32.png";